import styled from 'styled-components'
import { VARIABLES } from '../../themes'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'
// import {
//   default as TYPOGRAPHYS
// } from '../../themes/styles/variables/typographys'
// import {
//   default as MIXINS
// } from '../../themes/styles/helpers/mixins'
// import {
//   default as UTILITIES
// } from '../../themes/styles/helpers/utilities'

// Wrapper
// ============================================================
export const HomeContainerStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .welcome-message {
    color: ${VARIABLES.COLORS.BLUE_1};
    flex-wrap: wrap;
    display: block;

    .text-green {
      color: ${VARIABLES.COLORS.GREEN_5};
    }

    h1 {
      font-size: 95px;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      text-transform: uppercase;
    }

    h3 {
      font-size: 57.4px;
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      margin-top: -55px;
      text-transform: uppercase;
    }
  }

  .dashboard {
    flex-wrap: wrap;

    .task-group {
      margin-bottom: 31px;

      .heading {
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.LG};
        color: ${VARIABLES.COLORS.BLUE_1};
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_BOLD};
        margin-bottom: 9px;
      }

      .body {
        flex-wrap: wrap;
      }
    }
  }

  .contact-wrapper {
    line-height: 1.5;
    margin-top: 5rem;
    font-size: 13px;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    /* .dashboard {
      .task-group {
        .heading {
          font-size: ;
        }
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    .dashboard {
      .task-group {
        .heading {
          font-size: 18px;
        }
      }
    }
  }

  @media all and (max-width: 1366.98px) {
  }

  @media all and (max-width: 1280.98px) {
    .dashboard {
      .task-group {
        .heading {
          font-size: 16px;
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
  }
`
